"use client";
import { useEffect } from "react";
import PropTypes from "prop-types";

import setSearchId from "helpers/google-tag-manager/set-search-id";
import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

const GlobalGa4GtmSearchIdEvent = ({ pageName }) => {
  useEffect(() => {
    setSearchId(pageName).then((result) => {
      GTMPushEvent({ search_id: result });
    });
  }, []);
};

export default GlobalGa4GtmSearchIdEvent;

GlobalGa4GtmSearchIdEvent.propTypes = {
  pageName: PropTypes.string.isRequired,
};
